import React from 'react';
import { useNavigation } from 'react-day-picker'; // eslint-disable-next-line no-use-before-define,import/no-duplicates

import { format } from 'date-fns'; // eslint-disable-next-line no-use-before-define,import/no-duplicates

import ru from 'date-fns/locale/ru';
import { Box, IconButton, Typography } from '@mui/material';
import { Icon } from '@elements';
import ChevronLeft from '@images/left.icon.svg';
import ChevronRight from '@images/right.icon.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function DayPickerCaption(props) {
  var _useNavigation = useNavigation(),
      goToMonth = _useNavigation.goToMonth,
      nextMonth = _useNavigation.nextMonth,
      previousMonth = _useNavigation.previousMonth;

  return /*#__PURE__*/_jsxs(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    m: -1,
    children: [/*#__PURE__*/_jsx(IconButton, {
      disabled: !previousMonth,
      onClick: function onClick() {
        return previousMonth && goToMonth(previousMonth);
      },
      children: /*#__PURE__*/_jsx(Icon, {
        src: ChevronLeft,
        width: 16,
        height: 16
      })
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "h5",
      sx: {
        color: '#FFFFFF'
      },
      fontWeight: 500,
      textTransform: "capitalize",
      children: format(props.displayMonth, 'LLLL yyy', {
        locale: ru
      })
    }), /*#__PURE__*/_jsx(IconButton, {
      disabled: !nextMonth,
      onClick: function onClick() {
        return nextMonth && goToMonth(nextMonth);
      },
      children: /*#__PURE__*/_jsx(Icon, {
        src: ChevronRight,
        width: 16,
        height: 16
      })
    })]
  });
}